import getProp from '@f/get-prop'

export const isRequestingSourceSlug = (state) =>
  getProp('sourceSlug.isRequesting', state)

export const didFailToRequestSourceSlug = (state) =>
  getProp('sourceSlug.didRequestFail', state)

export const isValidSourceSlug = (state) =>
  getProp('sourceSlug.data', state)



// WEBPACK FOOTER //
// ./selectors/source-slug.js